let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3xX54")).then(() => parcelRequire('ieCfg'));